import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const ReconciliationOfShareCapitalAudit = () => {
  const pageid = 25; // Set the correct page ID for this section
  const [shareCapitalData, setShareCapitalData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchShareCapitalData = async () => {
      try {
        const res = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!res.ok) throw new Error(`HTTP error! ${res.status}`);
        const result = await res.json();

        if (!result.success || !Array.isArray(result.data)) {
          setShareCapitalData([]);
          setLoading(false);
          return;
        }

        // Map API response to desired format
        const mappedData = [
          {
            title: "",
            items: result.data.map((item) => ({
              label: item.pdf_name,
              file: item.upload_file_path,
            })),
          },
        ];

        setShareCapitalData(mappedData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setShareCapitalData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchShareCapitalData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Reconciliation Of Share Capital Audit | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full">
        <img
          src="./imgs/investors/investorsharecapitalaudit.jpg"
          alt="Chiripal Group Banner"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
          <div className="px-4 sm:px-8 md:px-16 lg:px-32">
            <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-6xl font-montserrat font-bold text-left">
              Reconciliation of Share Capital Audit
            </h1>
          </div>
        </div>
      </div>

      {/* PDF Section */}
      <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
        {loading ? (
          <p className="text-center">Loading reports...</p>
        ) : shareCapitalData.length === 0 ? (
          <p className="text-center">No reports available.</p>
        ) : (
          shareCapitalData.map((section, index) => (
            <div key={index} className="mb-12">
              {section.title && (
                <h2 className="text-xl font-extrabold text-[#0b3a6a] mb-4">{section.title}</h2>
              )}
              <ul className="list-disc pl-6 space-y-2 text-[#0b3a6a]">
                {section.items.map((item, idx) => (
                  <li key={idx}>
                    {item.file ? (
                      <a
                        href={`${API_PDF_URL}/${item.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <span className="text-gray-500">{item.label} (Coming Soon)</span>
                    )}
                  </li>
                ))}
              </ul>
              {index < shareCapitalData.length - 1 && (
                <hr className="mt-6 border-gray-300" />
              )}
            </div>
          ))
        )}
      </div>

      <Footer />
    </>
  );
};

export default ReconciliationOfShareCapitalAudit;
